package com.vizio.redwolf.auth.model

data class LoginRequestInfo(val email: String, val password: String, val reCaptchaToken: String? = null)